import { render, staticRenderFns } from "./drynessPathology.vue?vue&type=template&id=11ab2c3c&scoped=true"
import script from "./drynessPathology.vue?vue&type=script&lang=js"
export * from "./drynessPathology.vue?vue&type=script&lang=js"
import style0 from "./drynessPathology.vue?vue&type=style&index=0&id=11ab2c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ab2c3c",
  null
  
)

export default component.exports